{
  "state": {
    "DRAFT": "مسودة",
    "IN_CUSTODY": "في حوزتنا",
    "DELIVERED": "تم التسليم",
    "RETURNED": "مستردة",
    "CANCELLED": "ملغاة"
  },
  "party": {
    "depositor": "المودع",
    "intendedRecipient": "المستلم المقصود",
    "actualRecipient": "المستلم الفعلي",
    "noIntended": "غير محدد",
    "customerNotPresent": "العميل غير موجود"
  },
  "field": {
    "number": "رقم الأمانة",
    "reference": "الرقم المرجعي",
    "amount": "المبلغ",
    "currency": "العملة",
    "branch": "الفرع",
    "location": "مكان الأمانة",
    "notes": "ملاحظات",
    "status": "الحالة",
    "fullName": "الاسم الكامل",
    "phone": "الهاتف",
    "documentType": "نوع الوثيقة",
    "documentNumber": "رقم الوثيقة",
    "issuingCountry": "دولة الإصدار",
    "signature": "التوقيع",
    "recipientAvailable": "معلومات المستلم متوفرة",
    "depositEmployee": "موظف الإيداع",
    "deliveryEmployee": "موظف التسليم",
    "returnEmployee": "موظف الإرجاع"
  },
  "documentType": {
    "NATIONAL_ID": "هوية وطنية",
    "PASSPORT": "جواز سفر"
  },
  "message": {
    "PENDING": "بانتظار الإرسال",
    "SENT": "تم الإرسال",
    "FAILED": "فشل الإرسال",
    "resend": "إعادة الإرسال"
  },
  "flag": {
    "awaitingSync": "بانتظار المزامنة",
    "documentOwnedByOther": "الوثيقة مسجلة لعميل آخر",
    "referralPending": "بانتظار مراجعة المشرف",
    "signedEarlierVersion": "وُقّع على نسخة سابقة"
  },
  "action": {
    "newDeposit": "إيداع أمانة",
    "newDepositAgain": "إيداع جديد",
    "deliver": "تسليم أمانة",
    "returnToDepositor": "استرداد الأمانة",
    "return": "استرداد",
    "sendToTablet": "إرسال إلى التابلت",
    "resendToTablet": "إعادة الإرسال إلى التابلت",
    "confirmDeposit": "تأكيد الإيداع",
    "confirmDelivery": "تأكيد التسليم",
    "scanCode": "مسح الرمز",
    "takeDocumentPhoto": "تصوير الوثيقة",
    "printReceipt": "طباعة الوصل",
    "reprint": "إعادة طباعة",
    "referToSupervisor": "إحالة للمشرف",
    "reviewReferral": "مراجعة الإحالة",
    "cancelDeposit": "إلغاء الأمانة",
    "approve": "موافقة",
    "reject": "رفض"
  },
  "receipt": {
    "title": "وصل الإيداع",
    "heading": "وصل إيداع أمانة",
    "dateTime": "التاريخ والوقت",
    "declaration": "إقرار المودع",
    "qrAlt": "رمز الاستجابة السريعة للأمانة"
  },
  "edit": {
    "reason": "سبب التعديل",
    "history": "سجل التعديلات"
  },
  "referral": {
    "decision": "قرار المشرف"
  },
  "tablet": {
    "label": "جهاز التابلت",
    "choose": "اختر جهاز التابلت",
    "online": "متصل",
    "offline": "غير متصل",
    "none": "لا توجد أجهزة تابلت نشطة في هذا الفرع",
    "busy": "التابلت مشغول"
  },
  "compare": {
    "differs": "مختلف"
  },
  "file": {
    "loading": "جاري التحميل",
    "unavailable": "لا يمكن عرض الملف"
  },
  "match": {
    "title": "بيانات العميل المسجلة",
    "notFound": "لا يوجد عميل مسجل بهذا الرقم",
    "unavailable": "تعذر الوصول إلى نظام العملاء الآن",
    "level": "المستوى"
  }
}
